module.exports = __webpack_public_path__ + "img/Menu-09.86d3c1ec.png";